import pythonApiClient from './pythonBaseApi';

/**
 * Consulta DNI vía backend (miapi.cloud / RENIEC).
 * GET /consultas/generales/dni/{numero}
 */
const consultaDniReniecApi = {
  async consultarDni(numeroDocumento) {
    const digits = String(numeroDocumento || '').replace(/\D/g, '');
    const response = await pythonApiClient.get(
      `/consultas/generales/dni/${encodeURIComponent(digits)}`
    );
    return response.data;
  },
};

export default consultaDniReniecApi;
